import Component from '@glimmer/component';

export default class DropdownListButtonHeadingComponent extends Component {
  <template>
    <div role="heading"
      class={{@mixClass}}
      ...attributes
    >{{yield}}</div>
  </template>
}
